import { MethodCommands, MethodHandler, MethodProperties } from '@lentau/analytics/health-metrics/shared';
import {
  getPaymentTypesHandler,
  paymentBindingAddHandler,
  paymentBindingRemoveHandler,
} from './payment-method-handler';
import { MethodPropertiesKey } from '../../shared/consts';

export enum PaymentMethods {
  PaymentTypeSearch = 'paymentTypeSearch',
  PaymentBindingRemove = 'paymentBindingRemove',
  PaymentBindingAdd = 'paymentBindingAdd',
}
export const PAYMENT_HANDLER_LIST: MethodHandler = {
  [PaymentMethods.PaymentTypeSearch]: getPaymentTypesHandler,
  [PaymentMethods.PaymentBindingRemove]: paymentBindingRemoveHandler,
  [PaymentMethods.PaymentBindingAdd]: paymentBindingAddHandler,
};

export const PAYMENT_PROPERTIES_LIST: MethodProperties = new Map([
  [
    PaymentMethods.PaymentTypeSearch,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
  [
    PaymentMethods.PaymentBindingRemove,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
  [
    PaymentMethods.PaymentBindingAdd,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.CH,
      },
    ],
  ],
]);
